<template>
  <div>
    <Header>
      <RecruitNav/>
    </Header>
    <div v-if="toLoginPage==false" class="body-container">
      <h2><span class="mdi mdi-account mdi-36px"></span>プロフィール編集</h2>
      <div class="edit-box">
        <div class="img-area">
          <img class="img-icon" :src="user.profileIcon"/>
          <input class="file-input" type="file" name="resume" v-on:change="onFileChange">
          <button class="img-change-btn">変更</button>
        </div>
        <div class="edit-column">
          <p style="text-align: left;">名前</p>
          <div style="display: flex;">
            <input class="input left-in" v-model="user.username"/>
            <button class="button right-bt is-primary" @click="setProfileUser({'username': user.username}, 'user')">変更する</button>
          </div>
        </div>
        <div class="edit-column">
          <p style="text-align: left;">Eメール</p>
          <div style="display: flex;">
            <input class="input left-in" v-model="user.email"/>
            <button class="button right-bt is-primary" @click="setProfileUser({'email': user.email}, 'user')">変更する</button>
          </div>
        </div>
        <div class="edit-column">
          <p style="text-align: left;">電話番号</p>
          <div style="display: flex;">
            <input class="input left-in" v-model="user.profileTel"/>
            <button class="button right-bt is-primary" @click="setProfileUser({'tel': user.profileTel}, 'profile')">変更する</button>
          </div>
        </div>
        <div style="margin-top:32px" class = "pw-edit-box">
          <p style="margin-top:15px;">パスワード更新</p>
          <div style="margin:8px;" class="form">
            <p style="font-size:10px; text-align: left;">現在のパスワード</p>
            <b-field
              class="">
              <b-input type="password"
                      icon="lock"
                      minlength="8"
                      v-model="currentPassword"
                      password-reveal></b-input>
            </b-field>
            <p style="font-size:10px; text-align: left;">新しいパスワード</p>
            <b-field
              class="">
              <b-input type="password"
                      icon="lock"
                      minlength="8"
                      v-model="oldPassword"
                      password-reveal></b-input>
            </b-field>
            <p style="font-size:10px; text-align: left;">パスワードを確認</p>
            <b-field
              class="">
              <b-input type="password"
                      icon="lock"
                      minlength="8"
                      v-model="newPassword"
                      password-reveal></b-input>
            </b-field>
            <b-field style="margin-top: 50px;">
              <button class="button is-primary"
                      style="border-radius: 20px;"
                      v-if="disabled" :disabled="disabled">変更する</button>
              <button class="button is-primary"
                      style="border-radius: 20px;"
                      @click="setProfileUser({'email': user.email, currentPassword: currentPassword, newPassword: newPassword}, 'user_pw')"
                      v-if="!disabled" :disabled="disabled">変更する
              </button>
            </b-field>
          </div>
        </div>
      </div>
    </div>
    <div class="returnPage" v-if="toLoginPage">
      <p>パスワード変更完了しました。</p>
      <p>以下をクリックし、ログインしてください。</p>
      <button class="button" style="margin-top: 5vh; border-radius: 20px; color: white;">
        <router-link to="/login">ログインページへ</router-link>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"
import Loading from '@/components/animations/Loading'
import Header from '@/components/layouts/Header'
import RecruitNav from '@/views/Recruit/RecruitNav'
export default {
  name: "MyPage",
  componentName: "MyPage",
  components: {
    Loading,
    Header,
    RecruitNav
  },
  computed: {
    ...mapState("auth", ["user","pwChanged"]),
    ...mapState('employmentPage', ['contentsPublic', 'isContentsLoading', 'contentsCompany', 'contentsTops']),
    disabled () {
      return this.newPassword === '' || this.oldPassword === '' || this.oldPassword !== this.newPassword || this.oldPassword.length < 8 || this.newPassword.length < 8
    }
  },
  data () {
    return {
      newPassword: '',
      oldPassword: '',
      currentPassword: '',
      isUploaded: false,
      filename: 'loading',
      uploadedImage: '',
      file: null,
      isSlideLeft: false,
      isSlideRight: false,
      toLoginPage:false
  
    }
  },
  watch: {
    pwChanged: function () {
      if (this.pwChanged == 'ok') {
        this.logout()
      } else if (this.pwChanged == 'bad'){
        this.wrongPwBar()
      }
    },
  },
  methods: {
    setProfileUser (data, type) {
      this.$store.dispatch('auth/setProfileUser', {data: data, type: type})
        .then(() => {
          if (type != 'user_pw') {
            this.$buefy.snackbar.open({
              message: '変更しました',
              type: 'is-primary',
              position: 'is-top'
            })
          }
        })
        .catch(() => {
          this.$buefy.snackbar.open({
            message: '正常に変更が完了しませんでした。',
            type: 'is-danger',
            position: 'is-top'
          })
        })
    },
    setUserIcon (data) {
      this.$store.dispatch('auth/setUserIcon', {name: this.filename, data: data})
        .then(() => {
          this.$buefy.snackbar.open({
            message: '変更しました',
            type: 'is-primary',
            position: 'is-top'
          })
        })
        .catch(() => {
          this.$buefy.snackbar.open({
            message: '正常に変更が完了しませんでした。',
            type: 'is-danger',
            position: 'is-top'
          })
        })
    },
    // アップロードした画像を表示
    createImage (file) {
      let reader = new FileReader()
      reader.onload = (e) => {
        this.uploadedImage = e.target.result
        this.setUserIcon(this.uploadedImage)
      }
      reader.readAsDataURL(file)
    },
    onFileChange (e) {
      this.isUploaded = true
      let files = e.target.files || e.dataTransfer.files
      this.createImage(files[0])
      this.filename = files[0].name
      this.file = files[0]
    },
    substr (m, l) {
      return m.length > l ? m.substring(0, l - 3) + '...' : m
    },
    getCompanyName (id) {
      for (var i in this.contentsCompany) {
        if(this.contentsCompany[i].company_hash == id) return this.substr(this.contentsCompany[i].company_name, 50)
      }
      return ''
    },
    next () {
      this.$store.dispatch('employmentPage/nextContentsTops')
    },
    prev () {
      this.$store.dispatch('employmentPage/prevContentsTops')
    },
    logout () {
      this.$store.dispatch('auth/logout')
        .then(() => this.toLoginPage = true)
    },
    wrongPwBar () {
      this.$buefy.snackbar.open({
        message: 'パスワードが違います',
        type: 'is-primary',
        position: 'is-top'
      })
      this.pwChanged= ''
    },
  }
};
</script>

<style scoped>
.body-container {
  background: #fbfbfb;
  width: 100vw;
  height: 1000px;
  text-align: center;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
}
h2 {
  font-size: 24px;
  font-weight: 600;
  padding: 40px 20px;
}
h2 > span {
  margin-right: 10px;
}
.pw-edit-box {
  width: 64%;
  max-width: 3500px;
  height: 322px;
  border: solid thin #ccc;
  margin: auto;
}
.edit-box {
  width: 90%;
  max-width: 700px;
  height: 80%;
  border: solid thin #ccc;
}
.pw-edit-column {
  width: 70%;
  max-width: 400px;
  min-width: 250px;
  margin: auto;
}
.edit-column {
  width: 70%;
  max-width: 400px;
  min-width: 250px;
  margin: 15px auto;
}
.img-icon {
  width: 120px;
  height: 120px;
  object-fit: cover;
  background: #f2f2f2;
}
.left-in {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.right-bt {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.returnPage{
  display: inline-block;
  text-align: center;
  overflow-y: scroll;
  margin-top: 30px;
  height: 60vh;
  width: 80vw;
  min-height: 300px;
  max-width: 500px;
  padding: 30px;
  background-color: #F8F8F8;
  border-radius: 10px;
}
.img-change-btn {
  position: absolute;
  font-weight: bold;
  height: 30px;
  width: 100%;
  left: 0;
  bottom: 0;
  border: none;
  background: rgba(0, 0, 0, 0.8);
  text-align: center;
  color: white;
}
.img-area {
  position: relative;
  width: 120px;
  height: 120px;
  margin: 20px auto;
}
.file-input {
  z-index: 2;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/Recruit/MyPage.vue